<div class="edit-modal kw-dialog">

  <div class="modal-header">
    <div>
      <h2 class="modal-title">{{this.row.typeLabel}}<ng-container *ngIf="this.row.barcode"> · {{this.row.barcode}}</ng-container></h2>
      <div class="modal-subtitle">{{this.row.createdDate | date:'MMM d, y, h:mm a'}} · {{this.row.user || 'System'}}</div>
    </div>
    <button mat-icon-button class="close-btn" type="button" aria-label="Close" (click)="close()">
      <fa-icon [icon]="faXmark"></fa-icon>
    </button>
  </div>

  <div class="modal-body">
    <section class="form-section">
      <div class="section-head">
        <fa-icon [icon]="faReceipt" class="section-icon"></fa-icon>
        <h3>Transaction</h3>
      </div>
      <dl class="detail-list">
        <dt>Type</dt>
        <dd>
          <span class="status-tag" [ngClass]="'tone-' + this.row.tone">
            <span class="status-dot"></span>{{this.row.transaction.transactionType}}
          </span>
        </dd>
        <dt>{{"Product" | tenantWords}}</dt>
        <dd>{{this.row.products || '—'}}</dd>
        <dt>{{"Lot" | tenantWords}}</dt>
        <dd>{{this.row.lots || '—'}}</dd>
        <ng-container *ngIf="this.row.originalQty != null && this.row.adjustedQty != null">
          <dt>Quantity</dt>
          <dd class="change-cell">
            {{this.row.originalQty | number}}<span class="change-arrow">→</span>{{this.row.adjustedQty | number}}
            <span *ngIf="this.row.delta" class="change-delta" [class.up]="this.row.delta > 0" [class.down]="this.row.delta < 0">
              {{this.row.delta > 0 ? '+' : ''}}{{this.row.delta | number}}
            </span>
          </dd>
        </ng-container>
        <dt>{{"Reason" | tenantWords}}</dt>
        <dd>{{this.row.reason || '—'}}</dd>
      </dl>
    </section>

    <section class="form-section" *ngIf="this.row.moves.length">
      <div class="section-head">
        <fa-icon [icon]="faLocationDot" class="section-icon"></fa-icon>
        <h3>Location</h3>
      </div>
      <dl class="detail-list">
        <ng-container *ngFor="let move of this.row.moves">
          <dt>{{move.label | tenantWords}}</dt>
          <dd class="change-cell">{{move.from}}<span class="change-arrow">→</span>{{move.to}}</dd>
        </ng-container>
      </dl>
    </section>

    <section class="form-section" *ngIf="this.row.details">
      <div class="section-head">
        <fa-icon [icon]="faFileLines" class="section-icon"></fa-icon>
        <h3>Details</h3>
      </div>
      <p class="details-text">{{this.row.details}}</p>
    </section>
  </div>

  <div class="modal-footer">
    <button mat-stroked-button type="button" (click)="close()">Close</button>
  </div>

</div>
